import React from 'react';
import { AvailableForPurchaseProduct } from '../../../../../interfaces/merchants/resources/books/index';

import css from './BookingPurchaseProductList.module.scss';

import BookingPurchaseProduct from './components/BookingPurchaseProduct';

type Props = {
  products: AvailableForPurchaseProduct[];
};

export const BookingPurchaseProductList: React.FC<Props> = (props) => {
  const { products } = props;

  return (
    <div>
      {products.map((product) => (
        <div className={css.listItem}>
          <BookingPurchaseProduct key={product.public_id} product={product} />
        </div>
      ))}
    </div>
  );
};
